export default __webpack_public_path__ + "static/media/WednesdayRingRing.19227f25.png";